import { KeywordHelperType } from './enums/KeywordHelperType';

export class KeywordHelperContent {
	constructor(
		public readonly type: KeywordHelperType,
		public readonly degreeType?: string,
		public readonly url?: string,
		public readonly urlTitle?: string,
	) {}
}
